import { useMediaQuery } from '@mui/material';

export const useBrowserPrefersDarkMode = () =>
  useMediaQuery('(prefers-color-scheme: dark)');
